import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import i18next from '@/config/translations';
import Error404 from '@/pages/404/404';
import { Metadata } from '@/types/strapi/components/metadata';
import { Page } from '@/types/strapi/page';
import { NavBarData } from '@/components/cms/types';

export type PageComponentProps = {
  data?: Page;
  preview: boolean;
  slug?: string;
  metadata?: Metadata;
  pageContext: {
    locale?: string;
    locales?: string[];
    defaultLocale?: string;
    localizations?: string[];
  };
  navBarData: NavBarData;
};
/**
 * HOC that selects existing CMS template data that matches the wrapped page path, then adds the json as a translation resource bundle
 */
const withCMS =
  (PageComponent: FunctionComponent<PageComponentProps>) =>
  ({ data, preview, pageContext, navBarData }: PageComponentProps) => {
    const { asPath, query } = useRouter();
    if (!data) return <Error404 />;
    if (
      preview &&
      query?.preview !== (process.env.NEXT_PUBLIC_PREVIEW_CODE || 'true')
    )
      return <Error404 />;
    // TODO: replace 'enUS' with pageContext.locale once multiple locales are required
    if (!i18next.hasResourceBundle('enUS', asPath))
      i18next.addResourceBundle('enUS', asPath, data.attributes.json);

    return (
      <PageComponent
        data={data}
        slug={data?.attributes.slug}
        metadata={data?.attributes.metadata}
        navBarData={navBarData}
        preview={preview}
        pageContext={pageContext}
      />
    );
  };

export default withCMS;
